import { render, staticRenderFns } from "./ReturnsAndImportDeliveryForm.vue?vue&type=template&id=1c97c882"
import script from "./ReturnsAndImportDeliveryForm.vue?vue&type=script&lang=js"
export * from "./ReturnsAndImportDeliveryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports